import React, { useEffect, useRef, useState } from 'react';
import { Bath, ChevronDown, DoorOpen, Hammer, HardHat, Home, Layers, Menu, Phone, Trees, Wrench, X } from 'lucide-react';
import { services } from '../../data/services';
const LOGO = 'https://cdn.magicpatterns.com/uploads/9TVeR52UtqXcPBEydWX87j/image.png';
const iconMap = {
  layers: Layers,
  home: Home,
  wrench: Wrench,
  hardhat: HardHat,
  hammer: Hammer,
  doorOpen: DoorOpen,
  trees: Trees,
  bath: Bath
} as const;
const links = [{
  label: 'Honey-Do List',
  href: '#honey-do'
}, {
  label: 'Gallery',
  href: '#gallery'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'About',
  href: '#about'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    const onPointerDown = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);
  return <header className="sticky top-0 z-50" data-id="element-68" data-mp="1f6xzm2gqwyx5">
      <div className="hidden bg-ink text-white/80 md:block" data-id="element-69" data-mp="1f3trwv42nl1q">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-2 text-[13px]" data-id="element-70" data-mp="1a60lc0yuwp0x">
          <p data-id="element-71" data-mp="1bpaaifn3sgsb">
            Serving the Denver metro &amp; Front Range — Parker, Castle Rock,
            Centennial, Aurora &amp; beyond
          </p>
          <p className="text-white/60" data-id="element-72" data-mp="12naspl49l8ob">
            Licensed &amp; insured · 50+ years combined experience
          </p>
        </div>
      </div>

      <div className={['border-b transition-colors duration-300', scrolled ? 'border-black/10 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80' : 'border-transparent bg-white'].join(' ')} data-id="element-73" data-mp="16nkxwvk8fv24">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-3" data-id="element-74" data-mp="iztk1nj1n9yq">
          <a href="#top" className="flex items-center gap-3" data-id="element-75" data-mp="nxv70jjlbtfh">
            <img src={LOGO} alt="Restored Services" className="h-11 w-auto md:h-12" data-id="element-76" data-mp="nwbladf60q6b" />
            <span className="sr-only" data-id="element-77" data-mp="9zexyly99qu6">Restored Services Colorado</span>
          </a>

          <nav aria-label="Main" className="hidden items-center gap-5 md:flex lg:gap-8" data-id="element-78" data-mp="ex6q9h2tbeyw">
            <div ref={menuRef} className="relative" onMouseEnter={() => setMenuOpen(true)} onMouseLeave={() => setMenuOpen(false)} data-id="element-79" data-mp="3rjew925601xu">
              <button type="button" onClick={() => setMenuOpen(v => !v)} aria-expanded={menuOpen} aria-haspopup="true" className="flex items-center gap-1.5 py-2 text-sm font-medium text-ink-soft transition-colors hover:text-brand" data-id="element-80" data-mp="4a9sp93g89ow">
                Services
                <ChevronDown className={['h-4 w-4 transition-transform', menuOpen ? 'rotate-180' : ''].join(' ')} aria-hidden="true" data-id="element-81" data-mp="nzk9kqexl0ol" />
              </button>

              {menuOpen && <div className="absolute left-1/2 top-full w-[min(46rem,calc(100vw-3rem))] -translate-x-1/2 pt-3" data-id="element-82" data-mp="s38fl4nwzo7q">
                  <div className="overflow-hidden rounded-2xl border border-black/[0.08] bg-white shadow-xl" data-id="element-83" data-mp="2mhw2yp2kzaif">
                    <ul className="grid grid-cols-2 gap-1 p-3" data-id="element-84" data-mp="2rfnw1meyp2o7">
                      {services.map(service => {
                    const Icon = iconMap[service.icon];
                    return <li key={service.id} data-id="element-85" data-mp="30bwr6ovwpf4j">
                            <a href="#services" onClick={() => setMenuOpen(false)} className="flex gap-3 rounded-xl p-3 transition-colors hover:bg-sand" data-id="element-86" data-mp="23kbfnmfgsjzx">
                              <span className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-brand-tint text-brand" data-id="element-87" data-mp="2hj2ooufgzfh7">
                                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="3nylg3ujc27un" />
                              </span>
                              <span data-id="element-89" data-mp="3swmyed8xq352">
                                <span className="block text-sm font-semibold text-ink" data-id="element-90" data-mp="6wqzz66ntedz">
                                  {service.title}
                                </span>
                                <span className="mt-0.5 block text-[13px] leading-snug text-ink-soft/80" data-id="element-91" data-mp="200hydbao8px">
                                  {service.blurb}
                                </span>
                              </span>
                            </a>
                          </li>;
                  })}
                    </ul>
                    <div className="flex items-center justify-between gap-4 border-t border-black/[0.06] bg-sand px-5 py-3.5" data-id="element-92" data-mp="3fc2cu3c019d3">
                      <p className="text-[13px] text-ink-soft" data-id="element-93" data-mp="3aftpi2nne9uu">
                        Not sure where your project fits? We&apos;ll help you scope it.
                      </p>
                      <a href="#quote" onClick={() => setMenuOpen(false)} className="flex-none rounded-full bg-brand px-4 py-2 text-[13px] font-semibold text-white transition-colors hover:bg-brand-dark" data-id="element-94" data-mp="18lufrlq6c0k9">
                        Free quote
                      </a>
                    </div>
                  </div>
                </div>}
            </div>

            {links.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-ink-soft transition-colors hover:text-brand" data-id="element-95" data-mp="2t4y80ly3os79">
                {link.label}
              </a>)}
          </nav>

          <div className="hidden items-center gap-3 md:flex" data-id="element-96" data-mp="37u45a4ddo8ci">
            <a href="tel:+17205550142" className="hidden items-center gap-2 text-sm font-semibold text-ink transition-colors hover:text-brand lg:flex" data-id="element-97" data-mp="37vnj7obka7b4">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="1wgiigpuzqiu5" />
              (720) 555-0142
            </a>
            <a href="#quote" className="rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-99" data-mp="21aw8ecqvvxrf">
              Free Quote
            </a>
          </div>

          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-black/10 text-ink md:hidden" data-id="element-100" data-mp="1xwmjbrifncqv">
            {open ? <X className="h-5 w-5" data-id="element-101" data-mp="1jx4pgxqa59an" /> : <Menu className="h-5 w-5" data-id="element-102" data-mp="1jxmrkazmihqh" />}
            <span className="sr-only" data-id="element-103" data-mp="1f4jye3yrdaat">Toggle navigation</span>
          </button>
        </div>

        {open && <nav id="mobile-nav" aria-label="Mobile" className="max-h-[70vh] overflow-y-auto border-t border-black/10 bg-white px-6 py-4 md:hidden" data-id="element-104" data-mp="re7jua90cfb9">
            <button type="button" onClick={() => setMobileServicesOpen(v => !v)} aria-expanded={mobileServicesOpen} className="flex w-full items-center justify-between rounded-lg px-2 py-2.5 text-base font-medium text-ink-soft hover:bg-sand" data-id="element-105" data-mp="xwf5ghjldi2">
              Services
              <ChevronDown className={['h-4 w-4 transition-transform', mobileServicesOpen ? 'rotate-180' : ''].join(' ')} aria-hidden="true" data-id="element-106" data-mp="fvey227jgwhl" />
            </button>
            {mobileServicesOpen && <ul className="mb-2 ml-2 border-l border-black/10 pl-3" data-id="element-107" data-mp="tnlg5tu95djo">
                {services.map(service => <li key={service.id} data-id="element-108" data-mp="13johixha585k">
                    <a href="#services" onClick={() => setOpen(false)} className="block rounded-lg px-2 py-2 text-[15px] text-ink-soft hover:text-brand" data-id="element-109" data-mp="13kpu56dy22pe">
                      {service.title}
                    </a>
                  </li>)}
              </ul>}

            <ul className="flex flex-col gap-1" data-id="element-110" data-mp="2j2e3ol760zx6">
              {links.map(link => <li key={link.href} data-id="element-111" data-mp="2e3j9yo7ntqya">
                  <a href={link.href} onClick={() => setOpen(false)} className="block rounded-lg px-2 py-2.5 text-base font-medium text-ink-soft hover:bg-sand hover:text-brand" data-id="element-112" data-mp="2e4kurkeh9rt7">
                    {link.label}
                  </a>
                </li>)}
            </ul>

            <div className="mt-4 flex flex-col gap-2" data-id="element-113" data-mp="2x2os7hl062f6">
              <a href="#quote" onClick={() => setOpen(false)} className="rounded-full bg-brand px-5 py-3 text-center text-sm font-semibold text-white" data-id="element-114" data-mp="2x1vrax8q674y">
                Book your free quote
              </a>
              <a href="tel:+17205550142" className="rounded-full border border-black/10 px-5 py-3 text-center text-sm font-semibold text-ink" data-id="element-115" data-mp="rjob3samtea3">
                Call (720) 555-0142
              </a>
            </div>
          </nav>}
      </div>
    </header>;
}